import FP, { type Agent } from '@fingerprintjs/fingerprintjs';

let fpPromise: Promise<Agent> | null = null;

async function getFingerprint(): Promise<string | null> {
    try {
        if (!fpPromise) {
            fpPromise = FP.load(); // v3 OSS agent
        }
        const agent = await fpPromise;
        const result = await agent.get();
        return result.visitorId;
    } catch (error) {
        console.error('Error fetching visitor ID:', error);
        return null;
    }
}

export default getFingerprint;
